import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { getFilteredUsersFromProjectMembersForTaskUserSelector } from "~/store/selectors/selector.users.jsx";

export const SelectTaskAssignee = ({ onChange, projectId, hiddenFromClient, ...rest }) => {
  const { t } = useTranslation();
  const users = useSelector((state) =>
    getFilteredUsersFromProjectMembersForTaskUserSelector(state, projectId, hiddenFromClient)
  );

  const handleChange = useCallback(
    (value) => {
      typeof onChange === "function" && onChange({ assignee_id: Number(value) });
    },
    [onChange]
  );

  return (
    <Select
      defaultValue={t("No Assignee...")}
      noResultText={t("No result")}
      {...rest}
      onChange={handleChange}
      options={users}
      autoHeightMax={278}
    />
  );
};

SelectTaskAssignee.propTypes = {
  projectId: PropTypes.number,
  onChange: PropTypes.func,
  hiddenFromClient: PropTypes.bool,
};
